<script>
import indexFooter from "./footer.vue"
import router from "@/router/router";

export default {
  components: {
    indexFooter,
  },
  data() {
    return {
      activeName: 'first',
      imgData: [
        {"id": 1, "src": "https://zhenalther.oss-cn-beijing.aliyuncs.com/qxqy/indexImg/banner1.jpg"},
        {"id": 2, "src": "https://zhenalther.oss-cn-beijing.aliyuncs.com/qxqy/indexImg/brands-bg.png"},
        // {"id":3,"src":""}
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    toContent(){
      router.replace("/content")
      // router.push({
      //   name:'content',
      //   params:{
      //     toOrange:true
      //   }
      // })
    }
  }
}
</script>

<template>
  <div>
    <div>
<!--      <indexHeader></indexHeader>-->
    </div>
<!--    <br>-->
<!--    <br>-->
<!--    <br>-->
    <div>
      <el-carousel indicator-position="outside" height="500px">
        <el-carousel-item v-for="item in imgData" :key="item.id">
          <img :src="item.src" alt="" style="width: 100%;height: 100%">
        </el-carousel-item>
      </el-carousel>
    </div>
    <br>
    <div>
      <p class="center_p" style="font-size: 30px">产品与服务</p>
      <p class="center_p">融合业务场景，重塑企业核心竞争力</p>
    </div>
    <br>
    <div style="margin-top: 30px">
      <el-tabs v-model="activeName" stretch="" style="border: 0" >
        <el-tab-pane  name="first">
          <span slot="label" style="height: 100px"><img src="../../assets/shuzi-1.png" alt="数字营销"> <br>数字营销</span>
          <el-card class="box-card">
            <div style="background-color: rgba( 248,250,252);display: flex;justify-content:space-between;">
              <div style="padding-top: 50px;padding-left: 50px">
                <span>提供H5游戏、码券兑换、微信红包、全媒体互动等营销组合模式，驱动企业实现业绩增长。</span>
                <p></p>
                <p>· 全媒体营销</p>
                <p>· H5游戏营销</p>
                <p>· 数据化的精准营销</p>
              </div>
              <div>
                <img src="../../assets/shuzi.png" alt="" style="width: 100%">
              </div>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label" style="height: 100px"><img src="../../assets/jifen-1.png" alt="积分方案"> <br>积分方案</span>
          <el-card class="box-card">
            <div style="background-color: rgba( 248,250,252);display: flex;justify-content:space-between;">
              <div style="padding-top: 50px;padding-left: 50px">
                <span>深度分析企业积分需求，提供积分商城搭建、积分运营、积分礼品供应、积分兑换、积分营销等服务。</span>
                <p></p>
                <p>· 积分商城搭建</p>
                <p>· 积分代运营</p>
                <p>· 积分体系定制方案</p>
              </div>
              <div>
                <img src="../../assets/shuzi.png" alt="" style="width: 100%">
              </div>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane  name="three">
          <span slot="label" style="height: 100px"><img src="../../assets/zhihui-1.png" alt="智慧运营"> <br>智慧运营</span>
          <el-card class="box-card">
            <div style="background-color: rgba( 248,250,252);display: flex;justify-content:space-between;">
              <div style="padding-top: 50px;padding-left: 50px">
                <span>全渠道智能客服，7*24小时及时响应，降低用户投诉率，提高满意度，构建360°视图实现全链路运营。</span>
                <p></p>
                <p>· 200+运营团队</p>
                <p>· 1V1专属服务</p>
                <p>· 7*24小时及时响应</p>
              </div>
              <div>
                <img src="../../assets/shuzi.png" alt="" style="width: 100%">
              </div>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane  name="four">
          <span slot="label" style="height: 100px"><img src="../../assets/quanyi-1.png" alt="权益资源"> <br>权益资源</span>
          <el-card class="box-card">
            <div style="background-color: rgba( 248,250,252);display: flex;justify-content:space-between;">
              <div style="padding-top: 50px;padding-left: 50px">
                <span>严苛选品，与优质供应商合作，提供包含美食、饮品、出行、阅读、生活服务等口碑极佳的品牌商品。</span>
                <p></p>
                <p>· 官方渠道</p>
                <p>· 品类繁多</p>
                <p>· 无忧售后</p>
              </div>
              <div>
                <img src="../../assets/shuzi.png" alt="" style="width: 100%">
              </div>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div style="margin-top: 200px">
      <p class="center_p" style="font-size: 20px">基于海量权益产品 覆盖100+场景解决方案</p>
      <p class="center_p">多领域布局，提供数字化运营与营销、技术研发与生态构建的能力</p>
      <el-card>
        <div class="">
            <img src="../../assets/aaa.png" alt="">
        </div>
      </el-card>
    </div>
    <br>
    <br>
    <div>
      <div>
        <p class="center_p" style="font-size: 30px">海量行业客户选择</p>
        <p class="center_p" style="font-size: 20px"> 权益品牌</p>
        <div style="display: flex;justify-content: center">
          <img src="../../assets/logos-brandes.png" alt="权益品牌">
        </div>
        <div class="more"> <a @click="toContent()" class="more_a" href="javascript:(0)">了解更多 ></a></div>

      </div>
      <indexFooter></indexFooter>
    </div>
  </div>
</template>

<style>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.bg-purple-dark {
  background: #99a9bf;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-tabs__item {
  height: 150px;
}
.el-tabs__item:hover{
  color: orange;
}

.el-tabs__item.is-active {
  color: orange;
  opacity: 1;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.el-tabs__nav {
  justify-content: center;
}
.box-card{
  border: none;
}
.more {
  display: flex;
  justify-content: center;
  margin: 70px auto;
  width: 150px;
  height: 50px;
  border: 1px solid orange;
  border-radius: 20px;
}

.more_a {
  text-align: center;
  text-decoration: none;
  color: orange;
  line-height: 50px;
}
.el-tabs__active-bar{
  background: transparent;
}

:deep(.el-tabs__active-bar) {
  background-color: orange;
}
</style>
